import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify/lib';
import router from '../router'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
Vue.use(Vuetify);

Vue.use(VueGtag, {
  config: {
    id: 'G-MKD1PJYV7Z'
  }
}, router)

new Vue({
  router,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')
